import { mensagens, mutationTypes, notificacoesDefault } from '@/core/constants'

export default {
    methods: {
        mostrarNotificacaoErro(message) {
            if (message === 'GENERAL') {
                message = mensagens.DISCONNECTED
            }
            this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                message,
                type: 'error'
            })
        },
        mostrarNotificacaoErroDefault() {
            this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                message: notificacoesDefault.ERRO_DEFAULT,
                type: 'error'
            })
        },
        mostrarNotificacaoSucesso(message) {
            this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                message,
                type: 'success'
            })
        },
        mostrarNotificacaoSucessoDefault() {
            this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                message: notificacoesDefault.SUCESSO_DEFAULT,
                type: 'success'
            })
        },
        mostrarNotificacaoAviso(message) {
            this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                message,
                type: 'warning'
            })
        },
        mostrarConfirmacao({
                               titulo = 'Tudo certo',
                               subTitulo = '',
                               textoBotaoConfirm = 'Ok',
                               textoBotaoCancel = 'Cancelar',
                               textoBotaoDeny = 'Não',
                               exibirBotaoDeny = false,
                               icon = 'success',
                               html = '',
                               tamanhoModal = null,
                               exibirBotaoClose = false
                           }, callBack) {
            this.$swal({
                icon: icon,
                title: titulo,
                text: subTitulo,
                html: html,
                confirmButtonText: textoBotaoConfirm,
                cancelButtonText: textoBotaoCancel,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor: 'var(--v-primary-base)',
                showCancelButton: true,
                denyButtonText: textoBotaoDeny,
                showDenyButton: exibirBotaoDeny,
                reverseButtons: true,
                width: tamanhoModal,
                showCloseButton: exibirBotaoClose
            }).then(callBack.bind(this))
        },
    }
}
